module.exports = __webpack_public_path__ + "img/back-right-medal.32b7e691.png";